module.exports = __webpack_public_path__ + "img/image58.df823a21.jpg";